export default __webpack_public_path__ + "static/media/StartUp-Website-Design.e38327f5.png";